import styled from 'styled-components';

export const OptionWrapper = styled.div.attrs({ className: 'tiles-option' })`
  font-size: 14px;
  @media all and (min-width: 768px) {
    margin-top: 1rem;
  }
  strong {
    font-weight: bold !important;
  }
`;